import React, { Component } from "react";
import { QuestionTypes } from "../../../../constants/QuestionTypes";
import { getResponse } from "../../../../services/formService";
import * as Icon from "react-feather";
import CustomTooltip from "../../../common/CustomTooltip";
import {Markup} from "interweave";
import Radio from "@mui/material/Radio";
import {Checkbox} from "@mui/material";

class MatrixViewer extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Number: this.props.Question_Number,
    Question_Answers: this.props.Question_Answers,
    Matrix_QAs: this.props.Matrix_Answers,
    Matrix_Questions: this.props.Matrix_Questions,
    Matrix_Answers: [],
    uniqueQs: [],
    isMultiple: this.props.isMultiple,
    isTally: false,
    Responses: [],
    Response_Required: this.props.Response_Required,
    Required_Count: 0,
    PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : "",
    Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
    loading: true,
    isAllSelected: {}, // index matches uniqueQAs
    ShowSelectAll: this.props.ShowSelectAll, // List of Answer_Text values used to indicate which column should show select all option
  };

  async componentDidMount() {

    let uniqueQAs = [...new Set(this.state.Question_Answers.map(item => item.Answer_Text))],
        uniqueQs = [...new Set(this.state.Matrix_Questions.map(item => item.Question_ID))],
        //uniqueANum = [...new Set(this.props.Matrix_Answers.map(item => item.Answer_Number))],
        Matrix_Answers = [];

    uniqueQs.forEach(q => {
      Matrix_Answers = [...Matrix_Answers, this.props.Matrix_Answers.filter((a) => a.Question_ID === q)];
    });

    this.setState({ uniqueQs, uniqueQAs, Matrix_Answers })
    let Responses = [], uQ, Required_Count = 0;
    for (uQ of uniqueQs) {
      let q = this.state.Matrix_Questions.filter((mQ) => mQ.Question_ID === uQ)[0],
        isTally = q && q.Question_Type_ID === QuestionTypes.Numeric_Tally;
      this.setState({ isTally });

      if (this.state.Response_Required) {
        if (isTally) Required_Count += this.state.Matrix_Answers.length;
        else Required_Count++;
      }

      let Response = {};
      for (let answer of this.props.Matrix_Answers.filter((mA) => mA.Question_ID === uQ)) {
        if (!isTally) {
          Response['Answer_ID'] = answer.Answer_ID;
        } else {
          Response['Answer_ID'] = 0;
        }
      }

      let { data: subR } = await getResponse(this.state.PrimaryKey, this.state.Project_ID, q.Question_ID);
      for (let response of subR) {
        if (isTally) {
          Response['Answer_ID'] = parseFloat(response.Answer_Text);
        } else if (response.Answer_ID) {
          Response['Answer_ID'] = response.Answer_ID;
          Response['Answer_Text'] = response.Answer_Text;
        }
      }

      Responses.push({
        Question_ID: q.Question_ID,
        Answer_ID: Response['Answer_ID'],
        Answer_Text: Response['Answer_Text'] ? Response['Answer_Text'] : ''
      });
    }
    this.setState({ Required_Count, Responses, loading: false  });
    
    // Need to update responses here in order to save properly
    this.updateResponses(Responses);

    // check if all is selected for each answer column
    if (!this.state.isTally) {
      let isAllSelected = {};
      uniqueQAs.forEach((answerText) => {
        isAllSelected[answerText] = Responses.findIndex((r) => !r.Answer_Text || !r.Answer_Text.includes(answerText)) === -1;
      });
      this.setState({isAllSelected});
    }
  }

  handleResponse = (target, idx, ansId) => {
    let Responses = this.state.Responses;
    if (this.state.isTally) {
      Responses[idx].Answer_Text = parseFloat(target.value);
    }
    else {
      if (this.state.isMultiple) {
        if (target.checked && (Responses[idx].Answer_Text === undefined || Responses[idx].Answer_Text === '')) {
          Responses[idx].Answer_Text = target.value
        }
        else if (target.checked && !(Responses[idx].Answer_Text).includes(target.value)) {
          Responses[idx].Answer_Text = Responses[idx].Answer_Text + ',' + target.value
        }
        else if (!target.checked && (Responses[idx].Answer_Text).includes(target.value)) {
          Responses[idx].Answer_Text = ((Responses[idx].Answer_Text).split(',')).filter((r) => r !== target.value).toString()
        }
      }
      else {
        Responses[idx].Answer_Text = target.value
      }
      // update whether or not all have been checked for this answer column
      let isAllSelected = this.state.isAllSelected;
      if(!this.state.isMultiple) {
        Object.keys(isAllSelected).forEach(key => isAllSelected[key] = false);
      }
      isAllSelected[target.value] = this.state.Responses.findIndex((r) => !r.Answer_Text || !r.Answer_Text.includes(target.value)) === -1
      this.setState({isAllSelected});
    }

    this.updateResponses(Responses);
  };
  
  updateResponses = (Responses) => {
    this.setState({ Responses });
    this.props.OnUpdate(this.props.Question_Number, {
      Question_Number: this.props.Question_Number,
      Responses: Responses.filter((resp) => resp.Answer_Text !== undefined).length < this.state.Required_Count ? 
                  [] : Responses.filter((resp) => resp.Answer_Text !== undefined),
      Response_Required: this.state.Response_Required
    });
  }

  handleSelectAll = (checked, value, ansIndex) => {
    let Responses = this.state.Responses;
    let isAllSelected = this.state.isAllSelected;

    // handle for multiple selection
    if(this.state.isMultiple) {
      // if select all is checked, append column's answer text to response if not already present
      if (checked) {
        Responses.map((r) => {
          if (!r.Answer_Text) {
            r.Answer_Text = value;
          }
          else if (!r.Answer_Text.includes(value)) {
            r.Answer_Text = r.Answer_Text + ',' + value;
          }
          return r;
        });

        isAllSelected[value] = true;
      }
      // if select all is unchecked, remove column's answer text from response if present
      else {
        Responses.map((r) => {
          if (r.Answer_Text && r.Answer_Text.includes(value)) {
            r.Answer_Text = r.Answer_Text.split(',').filter((a) => a !== value).toString();
          }
          return r;
        });

        isAllSelected[value] = false;
      } 
    }
    // handle for single selection
    else {
      if(checked) {
        Responses.map((r) => r.Answer_Text = value);

        Object.keys(isAllSelected).forEach(key => isAllSelected[key] = false);
        isAllSelected[value] = true;
      }
      else {
        Responses.map((r) => r.Answer_Text = '');
        isAllSelected[value] = false;
      }
    }

    this.setState({isAllSelected});
    this.updateResponses(Responses);
  };

  render() {
    if (this.state.loading) return <div className="center">Loading...</div>;

    const { Question_ID, uniqueQs, uniqueQAs, Matrix_Questions, Matrix_Answers, isMultiple, isTally, Responses,
            isAllSelected, ShowSelectAll} = this.state;

    return (
      <table
        className="table table-hover table-bordered" key={"matrix" + Question_ID}>
        <thead>
          <tr>
            <th></th>
            {uniqueQAs.map((QA, idx) => {
              return (
                <th scope="col" key={idx}>
                  {QA}
                  {ShowSelectAll.length > 0 && ShowSelectAll.includes(QA) && !isTally && (
                    <div>
                      <label className="text-muted font-weight-light pr-1" style={{fontSize:14}}>Select All</label>
                      <input 
                        type='checkbox'
                        disabled={this.props.disabled}
                        value={QA}
                        checked={isAllSelected[QA]}
                        onChange={(e) => this.handleSelectAll(e.target.checked, e.target.value)}
                      />
                    </div>
                  )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {uniqueQs.map((mQ, idx) => {
            return (
              <tr key={'mQ:' + mQ}>
                <td>
                  <Markup content={Matrix_Questions.filter((q) => q.Question_ID === mQ)[0].Question_Text}/>
                  {Matrix_Questions.filter((q) => q.Question_ID === mQ)[0].Description && (
                    <CustomTooltip
                      title={Matrix_Questions.filter((q) => q.Question_ID === mQ)[0].Description}
                      placement="top"
                      className="text-muted pl-1 d-inline"
                    > 
                      <Icon.Info size={20} />
                    </CustomTooltip>
                  )}
                </td>
                {Matrix_Answers[idx].map((mA, mAIdx) => {
                  return (
                      <td key={"pQ:" + mA.Question_ID + "subQ:" + mAIdx}>
                        {isTally ?
                            <input
                                key={"pQ:" + mA.Question_ID}
                                type={"number"}
                                disabled={this.props.disabled}
                                value={Responses[idx]['Answer_Text']}
                                className={"form-control"}
                                name={"pQ:" + mA.Question_ID}
                                onChange={(e) => this.handleResponse(e.target, idx, mA.Answer_ID)}
                            />
                            :
                            isMultiple ?
                                <Checkbox
                                    key={"pQ:" + mA.Question_ID + "subQ:" + mAIdx}
                                    disabled={this.props.disabled}
                                    checked={Responses[idx]['Answer_Text'] && Responses[idx]['Answer_Text'].includes(mA.Answer_Text)}
                                    value={mA.Answer_Text}
                                    name={"pQ:" + mA.Question_ID + "subQ:" + mAIdx}
                                    onChange={(e) => this.handleResponse(e.target, idx, mA.Answer_ID)}
                                    size="small"
                                />
                                :
                                <Radio
                                    key={"pQ:" + mA.Question_ID}
                                    disabled={this.props.disabled}
                                    checked={Responses[idx]['Answer_Text'] && Responses[idx]['Answer_Text'].includes(mA.Answer_Text)}
                                    value={mA.Answer_Text}
                                    name={"pQ:" + mA.Question_ID}
                                    onChange={(e) => this.handleResponse(e.target, idx, mA.Answer_ID)}
                                    size="small"
                                />

                        }
                      </td>
                  )
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default MatrixViewer;
